var path = '/var/www/mmscny-cms/src/app/components/report-add/report-add.html';
var html = "<report-repository-add details=$ctrl.details page-title=\"Add Report\" disable-buttons=$ctrl.disableButtons is-short-details={{$ctrl.isShortDetails}} on-submit=$ctrl.onSubmit($event) on-cancel=$ctrl.onCancel($event) service-area-list=$ctrl.serviceAreaList program-years=$ctrl.programYears> </report-repository-add>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/report-add/report-add.html
// module id = 782
// module chunks = 0